import { axiosConfig } from "../../../config/axios.config"
import { Authorization, Protocols } from "../../../lib/parser"

export const uploadPostmanURL = async ({
	url,
	token,
	protocol: p,
	authorization,
	origin,
	basePath,
}: {
	url: string
	token: string
	protocol: Protocols
	authorization: Authorization | null
	origin: string
	basePath: string
}) => {
	const response = await axiosConfig.post(
		"/service",
		{
			url,
			protocol: p,
			authorization,
			origin,
			basePath,
		},
		{
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		}
	)
	const { data } = response

	return data
}
